import { PLATFORM_IDS } from "../conf";

const isOtherShop = (user) =>
	Array.isArray(user.publisher.platforms) &&
	user.publisher.platforms.findIndex(({ id }) => id === PLATFORM_IDS.other) >=
		0;

export default isOtherShop;
